import { IExpression } from "@@expressions";
import { IComponent } from "./IComponent";
import { TableColumnActionModel } from "./TableColumnActionModel";

export enum ListMessageChatTimestampDisplayFormat {
  Timestamp = "Timestamp",
  Relative = "Relative",
}

export type ListMessageChatItemModel = {
  ContentField?: string;
  TimestampField?: string;
  TimestampDisplayFormat?: ListMessageChatTimestampDisplayFormat;
  ContactNameField?: string;
  ContactIdField?: string;
  ContactLink?: string;
};

export type ListMessageChatModel = IComponent & {
  HeaderTitle?: string;
  HeaderIcon?: string;
  HeaderActions?: TableColumnActionModel[];
  UsePaper?: boolean;
  Items: IExpression;
  Message?: ListMessageChatItemModel[];
  ContentField?: string;
  TimestampField?: string;
  TimestampDisplayFormat?: ListMessageChatTimestampDisplayFormat;
  ContactNameField?: string;
  ContactIdField?: string;
  ContactLink?: string;
  CurrentContactId?: IExpression;
  OnMessagePosted?: IExpression;
};
